import Sinkhole from '@negative-epsilon/sinkhole';

export const TRACKING_CONFIG = {
    slug: '',
    place: '',
    event: '',
    sinkholeRealm: '',
    sinkholeApiKey: '',
    userBeacon: ''
}

export const sinkhole = new Sinkhole({
    realm: TRACKING_CONFIG.sinkholeRealm,
    api_key: TRACKING_CONFIG.sinkholeApiKey
});

const HOW = {
    TAP: 'click',
    SCROLL: 'scroll',
    RETRIEVE: 'retrieve',
    VISIT: 'visit',
    CANCEL: 'cancel',
    SEARCH: 'search',
    START: 'start',
    COMPLETE: 'complete',
}


export const record = async (event_type, metadata, buildName = true) => {
    // Build event name with how, what and where if available.
    // Where is screen, what is what, how is event_type

    const { what, screen, ...properties } = metadata;
    const eventName = buildName ? `${event_type}:${metadata.what}:${metadata.screen}` : event_type;

    // Remove undefined value
    Object.keys(properties).forEach(key => properties[key] === undefined && delete properties[key]);

    const currentTime =
        properties.timestamp && typeof properties.timestamp === 'number' ?
            properties.timestamp :
            Date.now();

    if (currentTime) {
        timestamp = new Date(currentTime).toISOString();
        delete properties.timestamp;
    }

    console.log('Tracking', eventName, JSON.stringify(properties, null, 2), TRACKING_CONFIG.userBeacon);
    sinkhole.track({
        name: eventName,
        properties,
        timestamp,
        user_id: TRACKING_CONFIG.userBeacon
    });
};

const tap = (what, metadata) => {
    try {
        record(HOW.TAP, { what, ...metadata });
    } catch (e) {
        console.log(e);
    }
}

const scroll = (what, metadata) => {
    try {
        record(HOW.SCROLL, { what, ...metadata });
    } catch (e) {
        console.log(e);
    }
}

const start = (what, metadata) => {
    try {
        record(HOW.START, { what, ...metadata });
    } catch (e) {
        console.log(e);
    }
}

const complete = (what, metadata) => {
    try {
        record(HOW.COMPLETE, { what, ...metadata });
    } catch (e) {
        console.log(e);
    }
}

export const flush = () => {
    sinkhole.flush();
}

export class Tracker {
    constructor(screen, component = 'RootView', placeId) {
        this.screen = screen;
        this.component = component;
        this.placeId = placeId;
    }

    static from(tracker) {
        return new this(tracker.screen, tracker.component, tracker.placeId);
    }

    setComponent(component) {
        this.component = component;
        return this;
    }

    setParams(params) {
        Object.assign(this, params);
        return this;
    }

    scroll(what, metadata) {
        if (this.contentObjectId) {
            scroll(what, {
                ...metadata,
                screen: this.screen,
                component: this.component,
                content_object_id: this.contentObjectId,
                content_object_type: this.contentObjectType
            });
        } else {
            scroll(what, {
                ...metadata,
                screen: this.screen,
                component: this.component,
            });
        }
    }

    tap(what, metadata) {
        if (this.contentObjectId) {
            tap(what, {
                ...metadata,
                screen: this.screen,
                component: this.component,
                content_object_id: this.contentObjectId,
                content_object_type: this.contentObjectType
            });
        } else {
            tap(what, {
                ...metadata,
                screen: this.screen,
                component: this.component,
            });
        }
    }

    start(what, metadata) {
        if (this.contentObjectId) {
            start(what, {
                ...metadata,
                screen: this.screen,
                component: this.component,
                content_object_id: this.contentObjectId,
                content_object_type: this.contentObjectType
            });
        } else {
            start(what, {
                ...metadata,
                screen: this.screen,
                component: this.component,
            });
        }
    }

    complete(what, metadata) {
        if (this.contentObjectId) {
            complete(what, {
                ...metadata,
                screen: this.screen,
                component: this.component,
                content_object_id: this.contentObjectId,
                content_object_type: this.contentObjectType
            });
        } else {
            complete(what, {
                ...metadata,
                screen: this.screen,
                component: this.component,
            });
        }
    }
}
